export default {
  api_keys: "Clés API",
  api_docs: "Documentation",
  keys_count: "{current} / {total} clés",
  unnamed: "Sans nom",
  edit_name: "Modifier le nom",
  upgrade_to_enable: "Passer à la version supérieure pour activer la fonctionnalité de clé API",
  no_api_keys: "Aucune clé API",
  generate_key: "Générer une clé",
  upgrade_to_generate: "Passer à la version supérieure pour générer une clé",
  api_calls: "Appels API",
  endpoint_stats: "Statistiques d'appel des points de terminaison",
  refresh: "Actualiser",
  free_plan_api_stats:
    "Les utilisateurs du plan gratuit ne peuvent pas afficher les statistiques d'appel API. Veuillez passer à la version supérieure pour afficher les données détaillées.",
  data_updates: "Mise à jour des données toutes les 5 minutes",
  api_call_logs: "Journaux d'appel API",
  api_call_logs_desc:
    "Seules les requêtes utilisant des clés API valides peuvent être consultées ici. Les données sont mises à jour toutes les 5 minutes",
  select_api_key: "Sélectionner une clé API",
  endpoint: "Point de terminaison",
  response_time: "Temps de réponse",
  api_quota: "Quota API",
  upgrade: "Passer à la version supérieure",
  current_plan: "Plan actuel",
  key_count: "Nombre de clés",
  call_limit: "Limite d'appels",
  no_access: "Pas d'accès",
  daily_limit: "{limit} appels par jour",
  total_limit: "Limite totale {limit} appels",
  monthly_limit: "{limit} appels par mois",
  calc_quota: "Quota de calcul",
  calc_and_report_quota: "Quota de calcul et de rapport",
  report_quota: "Quota de rapport",
  daily_report_quota: "Rapports quotidiens",
  extra_quota: "Quota supplémentaire : {count} appels",
  edit_key_name: "Modifier le nom de la clé",
  key_name: "Nom de la clé",
  key_name_placeholder: "Veuillez saisir un nom de clé",
  key_name_desc: "Donnez à votre clé API un nom facilement reconnaissable",
  feature_restricted: "Fonctionnalité restreinte",
  feature_restricted_desc1: "Votre plan actuel ne peut pas utiliser cette fonctionnalité",
  feature_restricted_desc2:
    "Les utilisateurs du plan gratuit ne peuvent pas utiliser les fonctionnalités liées aux clés API. Veuillez passer à un plan payant pour débloquer toutes les fonctionnalités.",
  upgrade_benefits: "Avantages du passage au plan supérieur :",
  benefit1: "Générer et gérer des clés API",
  benefit2: "Afficher les statistiques et tendances des appels API",
  benefit3: "Copier et utiliser des clés API",
  benefit4: "Quotas de calcul et de rapport plus élevés",
  benefit5: "Fonctionnalités plus avancées",
  response_data_details: "Détails des données de réponse",
  call_count: "{count} appels",
  name_required: "Le nom ne peut pas être vide",
  name_too_long: "La longueur du nom ne peut pas dépasser 20 caractères",
  key_generated: "Clé générée avec succès",
  key_deleted: "Supprimée avec succès",
  key_updated: "Nom mis à jour avec succès",
  upgrade_required: "Veuillez passer à la version supérieure",
  loading_docs: "Chargement de la documentation API...",
  docs_load_error: "Erreur de chargement de la documentation",
  docs_load_error_desc:
    "Une erreur s'est produite lors du chargement de la documentation API. Veuillez réessayer.",
  close_window: "Fermer la fenêtre",
  delete_confirm: "Confirmer la suppression ?",
  today: "Aujourd'hui",
  this_month: "Ce mois-ci",
  usage: "Utilisation",
  plan_quota: "Quota du plan : {count} appels",
  name: "Nom",
  api_key: "Clé API",
  created_at: "Créé le",
  action: "Action",
  response_status: "Code de statut",
  response_data: "Données de réponse",
  call_count_name: "Nombre d'appels",
  update_failed: "Échec de la mise à jour",
  restricted: "Restreint",
};
